import { HttpContext, httpResource } from '@angular/common/http';
import { Service, computed } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../../../core/http/http-context-tokens';

const RECURSO = `${environment.apiUrl}/sai/cartaservico/publico/banner`;

/** O erro fica local: sem banner, a seção mostra a faixa com o gradiente, sem modal. */
const ERRO_LOCAL = () => new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true);

/** Um item de `GET publico/banner`: só o código e se há arte própria para o celular. */
export interface BannerPublicoResponse {
  codBannerBan: number;
  bitPossuiImagemMobileBan: boolean;
}

/** Um slide do carrossel da homepage. */
export interface BannerSlide {
  id: number;
  /** A arte desktop, servida pela rota pública. */
  imagem: string;
  /** A arte do celular, ou `null` quando o banner não tem uma: o celular usa a desktop. */
  imagemMobile: string | null;
}

/**
 * Monta as URLs das artes de um banner. A mobile só é pedida quando a lista diz que ela
 * existe: a API responde 404 para a que falta, sem cair na desktop.
 */
export function paraSlide(item: BannerPublicoResponse): BannerSlide {
  const imagem = `${RECURSO}/${item.codBannerBan}/imagem`;

  return {
    id: item.codBannerBan,
    imagem,
    imagemMobile: item.bitPossuiImagemMobileBan ? `${imagem}?formato=mobile` : null,
  };
}

/**
 * Os banners que o portal do órgão exibe hoje, já na ordem do carrossel: ativos, com arte e
 * dentro da vigência, na ordem que o adm definiu. O portal não envia o órgão: o back-end o
 * resolve pelo host.
 */
@Service()
export class BannersPublicosService {
  private readonly bannersApi = httpResource<ResponseApi<BannerPublicoResponse[]>>(() => ({
    url: RECURSO,
    context: ERRO_LOCAL(),
  }));

  readonly carregando = computed(() => this.bannersApi.isLoading());

  /**
   * Os slides na ordem da API. Em falha, lista vazia: a seção fica com o gradiente.
   *
   * O `error()` é consultado antes do `value()`, que lança em estado de erro.
   */
  readonly slides = computed<readonly BannerSlide[]>(() => {
    if (this.bannersApi.error() !== undefined) return [];

    return (this.bannersApi.value()?.data ?? []).map(paraSlide);
  });
}
